import heartExplodeShort from "@components/SpriteIcon/sprites/heart-explode-short.png";

const spritesToPreload: string[] = [heartExplodeShort];

export default spritesToPreload;
